module.exports = __webpack_public_path__ + "img/logo.03caa5d1.svg";